import sdk from '@trazi/email/sdk/node';

const emailSDK = window => {
  return sdk(`${window.location.origin}/api`);
};

export default emailSDK;
